import "./Card.css";
function Card(props) {
  //add any extra css to this card.css dont forget wide space in ""
  const classes = "card " + props.className;
  return <div className={classes}>{props.children}</div>;
}

export default Card;
